<template>
    <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f mcw1">
        <div class="modal-header">
            <span class="modal__title">⚠️ Nelze zrušit rezervaci</span>
            <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal__content">
            <!-- Backend error message -->
            <div class="alert alert-warning" role="alert">
                <strong>Důvod:</strong> {{ errorMessage }}
            </div>

            <!-- Cancellation policy -->
            <div class="alert alert-info" role="alert">
                <strong>Pravidla zrušení rezervace:</strong><br>
                V případě, že se jedná o závažný důvod neúčasti, kontaktujte nás v době 8:00 - 16:00 ve všední dny. 
                Pokud nedojde ke zrušení rezervace a vy se nedostavíte, lekce v daném týdnu propadá.
            </div>
        </div>

        <div class="modal__action">
            <button type="button" class="btn btn-primary" @click.prevent="hideModal">
                Rozumím
            </button>
        </div>
    </vue-final-modal>
</template>

<script>
import {VueFinalModal} from "vue-final-modal";
import modalKkMixin from "./modal-kk-mixin";

export default {
    name: "modal-unsubscribe-error",
    components: {VueFinalModal},
    mixins: [modalKkMixin],
    props: {
        errorMessage: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
.alert {
    margin-bottom: 1rem;
}

.alert:last-child {
    margin-bottom: 0;
}

.alert-warning {
    background-color: #fff3cd;
    border-color: #ffc107;
    color: #856404;
}

.alert-info {
    background-color: #d1ecf1;
    border-color: #bee5eb;
    color: #0c5460;
}
</style>
